var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustryNewsIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 209,
    viewBox: "0 0 175 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.141 124.482C165.861 111.195 169.897 98.4169 169.897 87.4774C169.897 41.9844 133.008 5.10273 87.5 5.10273C41.992 5.10273 5.10273 41.9844 5.10273 87.4774C5.10273 98.4169 9.13931 111.195 15.8591 124.482C22.5416 137.694 31.6769 151.017 41.3942 162.931C51.1112 174.845 61.304 185.22 70.0183 192.567C74.383 196.247 78.2842 199.088 81.4974 200.98C84.9362 203.004 86.8609 203.497 87.5 203.497C88.1391 203.497 90.0638 203.004 93.5026 200.98C96.7158 199.088 100.617 196.247 104.982 192.567C113.696 185.22 123.889 174.845 133.606 162.931C143.323 151.017 152.458 137.694 159.141 124.482ZM87.5 208.6C104.327 208.6 175 135.79 175 87.4774C175 39.165 135.825 0 87.5 0C39.1751 0 0 39.165 0 87.4774C0 135.79 70.6731 208.6 87.5 208.6Z",
    fill: "#4BF990"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.783 89.2258C161.783 130.22 101.697 192 87.3913 192C73.0853 192 13 130.22 13 89.2258C13 48.232 46.3061 15 87.3913 15C128.476 15 161.783 48.232 161.783 89.2258Z",
    fill: "#4BF990"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2969 110.094L58.4764 103.437L57.3077 108.213L38.1281 114.87L39.2969 110.094Z",
    fill: "#03152D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2969 119.747L58.4764 113.09L57.3077 117.866L38.1281 124.523L39.2969 119.747Z",
    fill: "#03152D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7043 66.2504C69.7043 64.8927 70.805 63.7921 72.1627 63.7921H87.5214C88.8791 63.7921 89.9797 64.8927 89.9797 66.2504V79.6893C89.9797 81.047 88.8791 82.1476 87.5214 82.1476H72.1627C70.805 82.1476 69.7043 81.047 69.7043 79.6893V66.2504ZM74.621 68.7088V77.231H85.0631V68.7088H74.621Z",
    fill: "#03152D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.502 69.1304C98.502 67.7727 99.6026 66.672 100.96 66.672H116.319C117.677 66.672 118.777 67.7727 118.777 69.1304C118.777 70.4881 117.677 71.5887 116.319 71.5887H100.96C99.6026 71.5887 98.502 70.4881 98.502 69.1304ZM98.502 77.7696C98.502 76.4119 99.6026 75.3113 100.96 75.3113H116.319C117.677 75.3113 118.777 76.4119 118.777 77.7696C118.777 79.1273 117.677 80.228 116.319 80.228H100.96C99.6026 80.228 98.502 79.1273 98.502 77.7696Z",
    fill: "#03152D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1648 76.4584C44.7511 76.4584 41.9838 79.2257 41.9838 82.6394V122.956C41.9838 126.37 44.7511 129.137 48.1648 129.137C51.5784 129.137 54.3457 126.37 54.3457 122.956V111.437H59.2624V122.956C59.2624 129.085 54.2938 134.054 48.1648 134.054C42.0357 134.054 37.0671 129.085 37.0671 122.956V82.6394C37.0671 76.5103 42.0357 71.5417 48.1648 71.5417H56.804V76.4584H48.1648Z",
    fill: "#03152D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4266 58.5478C54.4266 49.8197 61.5021 42.7442 70.2302 42.7442H117.372C126.101 42.7442 133.176 49.8197 133.176 58.5478V118.25C133.176 126.978 126.101 134.054 117.372 134.054H48.1646V129.137H117.372C123.385 129.137 128.259 124.263 128.259 118.25V58.5478C128.259 52.5351 123.385 47.6609 117.372 47.6609H70.2302C64.2175 47.6609 59.3433 52.5351 59.3433 58.5478V113.837H54.4266V58.5478Z",
    fill: "#03152D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryNewsIconSelected);
export default __webpack_public_path__ + "static/media/industry-news-icon-selected.cd12ab8e0768127e42f37e5572d695e2.svg";
export { ForwardRef as ReactComponent };